import React, { useState, useEffect } from 'react';
import axios from "axios";
import { GetServiceCaller } from '../services/serviceCaller';
import Select from 'react-select';
// import '../Master.css';

const CommanDropdown = (props) => {
    const [options, setOptions] = useState([]);

    const fetchOptions = async () => {
        try {
            const response = await GetServiceCaller(props.url);
            const options = response.data.map(record => ({
                value: record.value,
                label: record.text
            }));
            setOptions(options);
        } catch (error) {
            console.error("Error fetching code options:", error);
        }
    };
    useEffect(() => {
        fetchOptions();
    }, []);
    const handleDropdownChange = (e,name) => {
        props.handleDropdownChange(e,name);
    }
    return (
        <>
        <Select  name={props.name} value={props.value} onChange={(e)=>handleDropdownChange(e,props.name)} options={[{label:'Select...',value:''},...options]} />
        </>
    )
}
export default CommanDropdown;

